import { Navigate } from 'react-router-dom';
import type { ProtectedRouteProps } from '../types/auth';

const ProtectedRoute = ({
  children,
  isAuthenticated,
  userRole,
  userProfile,
  allowedRoles = [],
}: ProtectedRouteProps) => {
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!userProfile) {
    return null;
  }

  const userRoles = new Set([
    userRole,
    userProfile.user_type ?? '',
    ...(userProfile.roles ?? []).map((role) => role.role_name),
  ]);
  const isAllowed = allowedRoles.some((role) => userRoles.has(role));

  if (!isAllowed) {
    const fallbackPath = userRole === 'project_owner' ? '/owner' : '/';
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
